import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const recurlyDirectConnector: AvailableServiceInfo = {
  label: 'Recurly',
  icon: require('./recurly.svg'),
  type: ConnectorType.Recurly,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your API key',
      propertyName: 'api_key',
    },
  ],
  connect: (params) => params,
};
